import $api from "../../../http";

export const registration = async (user) => {
  return await $api
    .post("/user/registration", user)
    .then((response) => response.data);
};
